import React from "react";
import util from "../../../../../../../utils/es5Utils";
import _ from "underscore";

export const textscannerIcon =
    "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 21H8.25V22.5H3C2.22349 22.5 1.58432 21.91 1.50732 21.1538L1.5 21V15.75H3V21Z' fill='white'/%3E%3Cpath d='M22.5 21L22.4927 21.1538C22.4208 21.8594 21.8594 22.4208 21.1538 22.4927L21 22.5H15.75V21H21V15.75H22.5V21Z' fill='white'/%3E%3Cpath d='M22.5 12.75H12H1.5V11.25H12H22.5V12.75Z' fill='white'/%3E%3Cpath d='M8.25 3H3V8.25H1.5V3C1.5 2.17157 2.17157 1.5 3 1.5H8.25V3Z' fill='white'/%3E%3Cpath d='M21.1538 1.50732C21.91 1.58432 22.5 2.22349 22.5 3V8.25H21V3H15.75V1.5H21L21.1538 1.50732Z' fill='white'/%3E%3C/svg%3E";

export default function TextScanner(props) {
    const widgets = util.widgetsOfType(props.context, "textscanner");
    const newProps = { ...props, widgets };
    const childComponents = _.values(props.childComponents).map((Component, id) => (
        <Component.component {...newProps} key={id} />
    ));

    if (widgets.length > 0 && childComponents.length > 0) {
        return [<label key="textScanner" text="Scanner" />, ...childComponents];
    }

    return null;
}
